import type {FinancialStatementArea} from "../../types";

// Financial statement areas — simplified, no nested processes/assertions
export const FINANCIAL_STATEMENT_AREAS: FinancialStatementArea[] = [
  {
    id: "expenditures",
    name: "Expenditures",
    description:
      "Purchasing, payables, and expense management cycles covering vendor payments, employee reimbursements, and corporate card programmes.",
  },
  {
    id: "revenue",
    name: "Revenue",
    description:
      "Order-to-cash and revenue recognition cycles covering customer billing, contract accounting, and collections.",
  },
  {
    id: "financial-reporting",
    name: "Financial Reporting",
    description: "Period-end close, journal entries, consolidation, and financial statement preparation processes.",
  },
];
